import React, { useEffect } from 'react';
import ClearIcon from '@material-ui/icons/Clear';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  FormContainer,
  LoginTitle,
  SignInButton,
} from './styles';

const ErrorMessage = ({ isMFA }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleButtonClick = () => {
    if (window.location.pathname === "/senha-funcionario" ||
        window.location.pathname === "/cadastro" ) {
          dispatch({ type: "SET_STEP", step: 0 });
          history.push('/acessar');
          return;
    }
    if (isMFA) {
      dispatch({ type: "SET_STEP", step: 0 });
    } else {
      dispatch({ type: "SET_STEP", step: 10 });
    }
  }

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <LoginTitle className="mb-3">
        Ocorreu um erro. Por favor, tente novamente mais tarde.
        <ClearIcon style={{ color: '#E8454F', fontSize: '30px' }} />
      </LoginTitle>
      
      {window.location.pathname !== "/cadastro" &&
        <SignInButton
          type="submit"
          className="mt-4"
          onClick={() => handleButtonClick()}
        >
          <span>Voltar para o início</span>
        </SignInButton>
      }
    </>
  );
};

export function ErrorNotification({ isMFA = true }) {
  return (
    isMFA ? (
      <FormContainer>
        <ErrorMessage isMFA={isMFA} />
      </FormContainer>
    ) : (
      <ErrorMessage isMFA={isMFA} />
    )
  );
}